export function hasValidationErrors(validation: { [key: string]: unknown }) {
  return Object.keys(validation).length > 0
}
